// extracted by mini-css-extract-plugin
export default {"content":"style_content__UiQe9","checkbox":"style_checkbox__XpH5Y"};